import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { arrayOf, shape, string } from "prop-types";
import Resource from "../Resource";
import MultiResource from "../Resource/multiResource";

function isElement(element) {
  return React.isValidElement(element);
}

const Resources = ({
  resources,
  title = "Your Resources",
  description = "Below are some materials that you might find useful throughout your search for employment and when in a role.",
}) => {
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">{title}</h2>
        <section className="section-body p-1">
          <p className="mb-2">{description}</p>
          {resources && resources.length !== 0 ? (
            resources.map((_resource) => {
              if (isElement(_resource)) {
                return <Fragment>{_resource}</Fragment>;
              }
              if (Array.isArray(_resource.buttons)) {
                return (
                  <MultiResource
                    key={`Resource${_resource.title}`}
                    {..._resource}
                  />
                );
              }
              return (
                <Resource key={`Resource${_resource.title}`} {..._resource} />
              );
            })
          ) : (
            <article>
              <h4>No resources have been added yet</h4>
              <p>Important and useful resources can be added to this page.</p>
              <p>
                If you are looking for something specific, please contact your
                HRGO consultant.
              </p>
            </article>
          )}
        </section>
        <div className="d-flex justify-content-end mt-2 mt-sm-0 flex-sm-row flex-column-reverse">
          <Link
            to="/profile"
            style={{ minWidth: "175px", marginRight: "5px" }}
            className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
          >
            Back to My Account
          </Link>
          <Link
            to="/profile/edit/resources"
            className="btn btn-block btn-primary col-12 col-sm-3 col-lg-2 my-2 "
          >
            Back
          </Link>
        </div>
      </div>
    </div>
  );
};

Resources.propTypes = {
  resources: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
      link: string,
      cta: string,
    })
  ),
  title: string,
  description: string,
};

export default Resources;
